import Header from '../../components/eventosacuvue/Header/index';
import Opticas from '../../components/eventosacuvue/Opticas/index';
import Lentes from '../../components/eventosacuvue/Lentes/index';
import Lentillas from '../../components/eventosacuvue/Lentillas/index';
import Mensaje from '../../components/eventosacuvue/Mensaje/index';
import Footer from '../../components/eventosacuvue/Footer/index';
import Bootstrap4 from '../../components/call-to-bootstrap/index';
import CallStyles from '../../components/call-to-styles/index';
import { useEffect } from 'react';

import '../../js/app.js';

const call = {
  css: 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css',
  js: 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.bundle.min.js',
  jquery: 'https://cdn.jsdelivr.net/npm/jquery@3.5.1/dist/jquery.slim.min.js'
};

const Style = () => {
  useEffect(() => {
    import('./styles.scss');
  }, []);
  return null;
}

function EventosAcuvue(props) {
  useEffect(() => {
    document.title = props.title;
  }, [props.title]);

  return (
    <div className='eventos-acuvue'>
      <CallStyles style={Style} />
      <Bootstrap4 cssCall={call.css} jsCall={call.js} jqueryCall={call.jquery} />
      <Header />
      <Opticas />
      <Lentes />
      <Lentillas />
      <Mensaje />
      <Footer />
    </div>
  );
}

export default EventosAcuvue;
